import React, { useState, FC, useEffect } from "react";
import TabButton from "../../../components/layout/Sections/TabButton";
import TabContent from "../../../components/layout/Sections/TabContent";
import Contaier from "../../../components/layout/Container/Container";
import Banner from "../../../components/layout/Sections/Banner";
import Footer from "../../../components/molecules/Footer/Footer";
import Header from "../../../components/molecules/Header/Header";

import TabPhillHome from "./TabPhillHome";
import TabPhillProfile from "./TabPhillProfile";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import CITESDashboard from "../../DashBoard/CITES/CITESDashboard";

const ApplicationForBirds = () => {
  const name = "E-services";
  const name2 = "Application Details";
  const buttonName = "Registration Mode";
  const buttonName2 = "Dashboard";
  const buttonName3 = "Application Information";

  let navigate = useNavigate();
  const location = useLocation();
  const [isFromRegistrationLink, setIsFromRegistrationLink] = useState(false);

  useEffect(() => {
    if (location.state?.from === "/application-registration") {
      setIsFromRegistrationLink(true);
    }
  }, [location.state]);
  const bannerType = location.state;
  const regType = location.state?.RegistrationType;
  const regId = location.state?.id;
  const tab = location.state?.activeTab;
  let RegType = "Birds";

  let bannerName;
  if (isFromRegistrationLink) {
    bannerName = "Application for Dragon for Tag List for Export/ Re-export";
  } else {
    if (
      bannerType?.RegistrationType === "DragonFish" ||
      bannerType === "DragonFish" ||
      RegType === "DragonFish" ||
      regType === 3
    ) {
      bannerName =
        "Application for Captive-Bred Dragon Fish for Tag List for Export/ Re-export";
    } else if (
      bannerType?.RegistrationType === "Crocodile" ||
      bannerType === "Crocodile" ||
      RegType === "Crocodile" ||
      regType === 2
    ) {
      bannerName =
        "Application for Crocodile Skin for Tag List for Export/ Re-export";
    } else {
      bannerName =
        "Application for Captive-Bred Birds for Tag List for Export/ Re-export";
    }
  }
  const [activeButton, setActiveButton] = useState<string>("v-pills-home-tab");
  const [activeTab, setActiveTab] = useState<string>("v-pills-home");

  const handleButtonClick = (buttonId: string, tabId: string) => {
    setActiveButton(buttonId);
    setActiveTab(tabId);
  };

  useEffect(() => {
    if (regId !== undefined) {
      setActiveButton("v-pills-home-tab");
      setActiveTab("v-pills-home");
    }
    if (tab === "dashboard") {
      setActiveButton("v-pills-dashboard-tab");
      setActiveTab("v-pills-dashboard");
      // setBannerType("HarvestDetailsDashboard");
    }
  }, [regId, tab]);

  interface TabPages {
    [key: string]: FC<any>; // Use the appropriate prop type for your components
  }

  const tabPages: TabPages = {
    "v-pills-home": TabPhillProfile,
    "v-pills-dashboard": CITESDashboard,
    // ... add other tab pages here
  };

  return (
    <>
      <Header />
      <Contaier>
        <Banner name={bannerName} uiClass="banner-bg" />
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-2-5">
                <div className="filter-cnt">
                  <h3>{name}</h3>
                  <span>{name2}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-home-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick("v-pills-home-tab", "v-pills-home")
                      }
                    >
                      {buttonName}
                    </TabButton>
                    <TabButton
                      buttonId="v-pills-dashboard-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-dashboard-tab",
                          "v-pills-dashboard"
                        )
                      }
                    >
                      {buttonName2}
                    </TabButton>
                    {/* <TabButton
                      buttonId="v-pills-services-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-services-tab",
                          "v-pills-services"
                        )
                      }
                    >
                      {buttonName3}
                    </TabButton> */}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-9-5">
                <div className="tab-content" id="v-pills-tabContent">
                  {Object.keys(tabPages).map((tabId) => (
                    <TabContent key={tabId} tabId={tabId} activeTab={activeTab}>
                      {tabPages[tabId]({ RegistrationType: bannerType })}
                    </TabContent>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
};

export default ApplicationForBirds;
